module.exports = __webpack_public_path__ + "assets1775130923925/img/error-404.94756dcf.svg";